import { withPrefix } from 'gatsby'

const canonicalUrl = url => {
  return url.includes(process.env.GATSBY_WP_URL)
    ? process.env.GATSBY_SITE_URL +
        withPrefix(url.replace(process.env.GATSBY_WP_URL, ''))
    : url
}
export default canonicalUrl
